import React from 'react';

const InformationIcon = props => (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx="32" cy="32" r="30" stroke="#FF9C29" strokeWidth="4"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M32.0003 46.399C32.8136 46.399 33.5936 46.0759 34.1687 45.5008C34.7438 44.9256 35.0669 44.1456 35.0669 43.3323C35.0669 42.519 34.7438 41.7389 34.1687 41.1638C33.5936 40.5887 32.8136 40.2656 32.0003 40.2656C31.1869 40.2656 30.4069 40.5887 29.8318 41.1638C29.2567 41.7389 28.9336 42.519 28.9336 43.3323C28.9336 44.1456 29.2567 44.9256 29.8318 45.5008C30.4069 46.0759 31.1869 46.399 32.0003 46.399Z" fill="#FF9C29"/>
        <rect x="29.6006" y="16" width="4.8" height="20" rx="2.4" fill="#FF9C29"/>
    </svg>
    
);

export default InformationIcon;